export const PAR_Q_KEYS = [
    'q1_heart',
    'q2_chest_pain_activity',
    'q3_chest_pain_rest',
    'q4_balance',
    'q5_bone_joint',
    'q6_medications',
    'q7_other',
];

export function createEmptyAnamnesis() {
    const par_q = {};
    PAR_Q_KEYS.forEach((key) => {
        par_q[key] = { answer: '', note: '' };
    });
    return {
        _v: 1,
        par_q,
        pathological: {
            conditions: '',
            medications: '',
            surgeries: '',
            allergies: '',
        },
        musculoskeletal: {
            injuries_past: '',
            injuries_current: '',
            limitations: '',
            physiotherapy: '',
        },
        lifestyle: {
            occupation: '',
            sleep_hours: '',
            smoking: '',
            alcohol: '',
            notes: '',
        },
        training_history: {
            sports_background: '',
            current_frequency: '',
            experience_level: '',
        },
        goals: {
            primary: '',
            secondary: '',
            target_note: '',
            target_date: '',
        },
        professional_notes: '',
        next_review_date: '',
    };
}

export function normalizeAnamnesisFromApi(raw) {
    const base = createEmptyAnamnesis();
    if (!raw || typeof raw !== 'object') return base;

    PAR_Q_KEYS.forEach((key) => {
        const item = raw.par_q?.[key];
        if (item && typeof item === 'object') {
            base.par_q[key] = {
                answer: item.answer === 'yes' || item.answer === 'no' ? item.answer : '',
                note: item.note ?? '',
            };
        }
    });

    ['pathological', 'musculoskeletal', 'lifestyle', 'training_history', 'goals'].forEach((section) => {
        if (!raw[section] || typeof raw[section] !== 'object') return;
        Object.keys(base[section]).forEach((field) => {
            const val = raw[section][field];
            if (val === null || val === undefined) {
                base[section][field] = '';
            } else if (field === 'physiotherapy') {
                base[section][field] = val === true ? 'yes' : val === false ? 'no' : '';
            } else {
                base[section][field] = String(val);
            }
        });
    });

    base.professional_notes = raw.professional_notes ?? '';
    base.next_review_date = raw.next_review_date ?? '';

    return base;
}

export function prepareAnamnesisForSave(form) {
    const out = JSON.parse(JSON.stringify(form));
    PAR_Q_KEYS.forEach((key) => {
        const ans = out.par_q[key]?.answer;
        out.par_q[key].answer = ans === 'yes' || ans === 'no' ? ans : null;
        const note = String(out.par_q[key]?.note ?? '').trim();
        out.par_q[key].note = note || null;
    });
    ['pathological', 'musculoskeletal', 'lifestyle', 'training_history', 'goals'].forEach((section) => {
        Object.keys(out[section]).forEach((field) => {
            let val = out[section][field];
            if (field === 'physiotherapy') {
                out[section][field] = val === 'yes' ? true : val === 'no' ? false : null;
                return;
            }
            if (field === 'sleep_hours') {
                const n = parseInt(val, 10);
                out[section][field] = Number.isFinite(n) ? n : null;
                return;
            }
            val = String(val ?? '').trim();
            out[section][field] = val || null;
        });
    });
    out.professional_notes = String(out.professional_notes ?? '').trim() || null;
    out.next_review_date = String(out.next_review_date ?? '').trim() || null;
    return out;
}

/** Id sezioni UI (salvataggio per gruppo). */
export const ANAMNESIS_SECTION_IDS = [
    'par_q',
    'pathological',
    'musculoskeletal',
    'lifestyle',
    'training',
    'professional',
];

export function anamnesisSectionSnapshot(form, sectionId) {
    switch (sectionId) {
    case 'par_q':
        return form.par_q;
    case 'pathological':
        return form.pathological;
    case 'musculoskeletal':
        return form.musculoskeletal;
    case 'lifestyle':
        return form.lifestyle;
    case 'training':
        return { training_history: form.training_history, goals: form.goals };
    case 'professional':
        return {
            professional_notes: form.professional_notes,
            next_review_date: form.next_review_date,
        };
    default:
        return null;
    }
}

export function isAnamnesisSectionDirty(form, savedForm, sectionId) {
    return JSON.stringify(anamnesisSectionSnapshot(form, sectionId))
        !== JSON.stringify(anamnesisSectionSnapshot(savedForm, sectionId));
}
